module.exports = __webpack_public_path__ + "img/knights-logo-full.fa0fc160.png";